import React from 'react'

export const hasNoReviews = (reviewCount?: number | null): boolean => !reviewCount || reviewCount === 0

export const NoReviewsYetBadge: React.FC = () => (
  <span className="inline-flex shrink-0 items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
    No reviews yet
  </span>
)
